/**
 *   PROPERTIES
 *   This is the global data that our app references for section headings,
 *   error messages, question text, etc.
 **/
export const globalData = {
    encryptedParamsParam: 'e',
    
    commentBoxIntroText: 'Tell us more about ',

    commentBoxCheckBoxText: 'Check here if this was not part of your tour',

    debounceTime: 500,

    errorMessages: {
        apiPost500error : 'There was an error submitting your feedback. Please let your Tour Director know and resubmit your answers later.',
        apiDirtyPostError: 'There was an error contacting the EF server. Your answers are safe and sound, but cannot be sent back to EF. Please make sure you have a working Internet connection, and let your Tour Director know if problems continue.',
        apiGetServerError: 'Sorry! We couldn’t load your evaluations. Please let your Tour Director know and try again later.',
        apiGetNoInternet: 'Sorry! We couldn’t load your evaluations. Please make sure you\'re connected to the Internet and try again.',
        apiGetExpiredEvaluation: 'Sorry! This survey is no longer available.',
        noInternetConnection: 'Sorry! This device is not connected to the Internet. Your answers are safe and sound, but cannot be sent back to EF. Please tell your Tour Director and try again later.',
        submissionStatus: 'We were unable to submit your tour data. Please make sure you are connected to the internet, and contact your regional office if problems continue.'
    },

    dragHelperText: 'Drag (or leave) each item beneath the emoji that best represents your reaction.',

    fiveScaleLabelText: [
        'Strongly disagree',
        'Disagree',
        'Neutral',
        'Agree',
        'Strongly agree'
    ],

    fourScaleLabelText: [
        'Poor',
        'Fair',
        'Good',
        'Excellent'
    ],

    noInternetButtonText: 'Return to the homepage',

    noUnsentAnswersMessage: 'There are no answers to send back',

    pulseCheckPlaceholder: '',

    questionTypes: {
        nps: 'NetPromoterScore'
    },

    ratingHelperLow: 'Not at all likely',

    ratingHelperHigh: 'Extremely likely',

    returnButtonText: 'Return to the homepage',

    standardOverallQuestionsLength: 5,

    tdSuccessfullSendMessage: 'Success!',

    thankYouMessage: 'Thank you',
    
    unsentAnswersMessage: 'has answered questions that have not been submitted'
};



// WEBPACK FOOTER //
// ./application/global/js/globalData.js